var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-upload",
        {
          staticClass: "upload-demo",
          staticStyle: { display: "inline-block", "margin-right": "10px" },
          style: "width:100px;float:left;height:50px;",
          attrs: {
            "show-file-list": false,
            action: _vm.action,
            accept: _vm.accept,
            "on-success": _vm.uploadSuccessCommon,
            "before-upload": _vm.beforeAvatarUploadCommon,
            "on-exceed": _vm.handleExceedCommon,
            "file-list": _vm.files,
            "with-credentials": ""
          }
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { margin: "10px 3px" },
              attrs: { size: "small", type: "primary", disabled: _vm.disabled }
            },
            [_vm._v("上传图片")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.imagesList.length
        ? _vm._l(_vm.imagesList, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticStyle: {
                  float: "left",
                  width: "50px",
                  height: "50px",
                  margin: "0 10px",
                  border: "1px solid #ddd"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { position: "relative" } },
                  [
                    _vm.value.indexOf("pdf") > -1
                      ? [
                          _c("img", {
                            staticStyle: { width: "50px", height: "50px" },
                            attrs: {
                              src:
                                "https://static3.yishouapp.com/obs/tools/def/2022/4/20/dc7feaed3c8006c0f0c2c2a46b2d41ed.png"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleOpen(_vm.origin + "/" + item)
                              }
                            }
                          })
                        ]
                      : _c("img", {
                          staticStyle: { width: "50px", height: "50px" },
                          attrs: { src: _vm.origin + "/" + item },
                          on: {
                            click: function($event) {
                              return _vm.previewImage(item)
                            }
                          }
                        }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        style: {
                          width: "15px",
                          height: "15px",
                          position: "absolute",
                          top: "-5px",
                          right: "-5px",
                          display: _vm.disabled ? "none" : "block"
                        },
                        on: {
                          click: function($event) {
                            return _vm.deleteImgCommon(item)
                          }
                        }
                      },
                      [
                        _c("img", {
                          staticStyle: { width: "15px", height: "15px" },
                          attrs: {
                            src:
                              _vm.origin +
                              "/201804/13/15235857625ad012e238658.png"
                          }
                        })
                      ]
                    )
                  ],
                  2
                )
              ]
            )
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b304c0b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b304c0b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/supply/updateSupplyComponents/UploadCommonTemplate.vue
// module id = null
// module chunks = 